export default __webpack_public_path__ + "static/media/image03.0e8963f8.jpg";